import 'antd/dist/antd.css';

import {
  Box,
  Button,
  Card,
  Dialog,
  Form,
  Input,
  Message,
  NumberPicker,
  Pagination,
  Table,
  TimePicker,
} from '@alifd/next';
import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';

import { getVisitorEntryTime } from '@/helpers/getVisitorEntryTime';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const VisitorAccessStatisticsList = () => {
  const visitorAppointmentRegistration = client.service(
    'visitorAppointmentRegistration'
  );
  const communityData = client.service('communityData');
  const [visitorAppointmentArr, setVisitorAppointmentArr] = useState([]);
  const [visitorAppointmentAllArr, setVisitorAppointmentAllArr] = useState([]);
  const [communityDataArr, setCommunityDataArr] = useState([]);
  const [addTimeDialog, setAddTimeDialog] = useState(false);
  const [visitorId, setVisitorId] = useState('');
  const [count, setCount] = useState(0);
  const [minute, setMinute] = useState(0);

  // sort
  const [curdataIndex, setcurDataIndex] = useState('householdNumber');
  const [curorder, setcurOrder] = useState('asc');

  // 抓入場訪客
  async function funFindVisitor() {
    const result = await visitorAppointmentRegistration.find({
      query: {
        $or: [
          // 篩選已入場或是預約中的訪客
          {
            visitorsStatus: { $in: ['已入場'] },
          },
          {
            $and: [
              // 只顯示預約中且三天內預約的訪客的訪客
              { visitorsStatus: { $in: ['預約中'] } },
              {
                reservationTimeStart: {
                  $gte: Number(
                    // 搜尋預約時間大於等於從今天00：00分開始往前兩天的記錄
                    new Date(
                      moment()
                        .startOf('day')
                        .subtract(2, 'days')
                        .format('YYYY-MM-DD HH:mm:ss')
                    )
                  ),
                },
              },
            ],
          },
        ],
        $sort: { reservationTimeStart: -1 },
      },
    });
    return result && result.data ? result.data : [];
  }
  async function funUpdateVisitor(id, obj) {
    await visitorAppointmentRegistration.patch(id, obj);
  }
  const serverVisitorDataUpdate = (dataIndex, order) => {
    const rdataIndex = dataIndex || curdataIndex;
    const rorder = order || curorder;

    funFindVisitor().then((result) => {
      setVisitorAppointmentArr(
        result.sort((a, b) => {
          const result = (
            typeof a[rdataIndex] === 'number'
              ? a[rdataIndex].toString()
              : a[rdataIndex]
          ).localeCompare(
            typeof b[rdataIndex] === 'number'
              ? b[rdataIndex].toString()
              : b[rdataIndex]
          );
          return (rorder === 'asc') === result > 0 ? 1 : -1;
        })
      );

      setVisitorAppointmentAllArr(
        result.sort((a, b) => {
          const result = (
            typeof a[rdataIndex] === 'number'
              ? a[rdataIndex].toString()
              : a[rdataIndex]
          ).localeCompare(
            typeof b[rdataIndex] === 'number'
              ? b[rdataIndex].toString()
              : b[rdataIndex]
          );
          return (rorder === 'asc') === result > 0 ? 1 : -1;
        })
      );
    });
  };
  const onTableSort = (dataIndex, order) => {
    console.log('==dataIndex:', dataIndex, 'order:', order);
    setcurDataIndex(dataIndex);
    setcurOrder(order);
    serverVisitorDataUpdate(dataIndex, order);
  };
  useEffect(() => {
    serverVisitorDataUpdate();
  }, []);
  useEffect(() => {
    communityData
      .find({})
      .then((res) => {
        setCommunityDataArr(res.data[0]);
      })
      .catch((error) => {
        console.log('== find  communityData data fail:', error);
      });
  }, []);

  function searchRender(value) {
    // input search filter
    if (value.length > 0) {
      const sortedArr = [...visitorAppointmentAllArr]
        .map((e) => {
          let hasIncludes = false;
          Object.keys(e).forEach((ee) => {
            const val2 = e[ee];

            if (val2 !== null) {
              if (val2.toString().includes(value)) hasIncludes = true;
            }
          });
          if (hasIncludes) return e;
          return false;
        })
        .filter((e) => e !== false);

      setVisitorAppointmentArr([...sortedArr]);
    } else {
      setVisitorAppointmentArr([...visitorAppointmentAllArr]);
    }
  }

  // 換頁
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = visitorAppointmentArr.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  return (
    <>
      <Dialog
        hasMask
        className={styles.dialog}
        visible={addTimeDialog}
        onOk={() => {
          const carArr = currentPosts.filter((x) => x._id === visitorId);
          console.log({ carArr: carArr[0] });
          if (carArr && carArr.length > 0) {
            Swal.fire({
              title: '確定新增此訪客辨識時間?',
              text: `加時:${(
                parseInt(
                  count * 1000 * 60 * 60 +
                    parseInt(moment(minute).format('mm'), 10) * 1000 * 60,
                  10
                ) /
                1000 /
                60 /
                60
              ).toFixed(2)}小時`,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#BEBEBE',
              confirmButtonText: '確定',
              cancelButtonText: '取消',
            }).then((result) => {
              if (result.isConfirmed) {
                carArr[0].faceEndTime =
                  new Date().getTime() +
                  count * 1000 * 60 * 60 +
                  parseInt(moment(minute).format('mm'), 10) * 1000 * 60;
                funUpdateVisitor(carArr[0]._id, carArr[0])
                  .then(() => {})
                  .then((res) => {
                    console.log('==carNumber update success:', res);

                    setCount(0);
                    setMinute(0);
                    setVisitorId('');
                    serverVisitorDataUpdate();
                    setAddTimeDialog(false);

                    Swal.fire('成功!', '此訪客加時成功', 'success');
                  })
                  .catch((error) => {
                    console.log('==carNumber update fail:', error);
                    Message.error(`${error}`);
                  });
                // 20220315 增加訪客辨識加時成功推播
                axios('/ezcon/api/emitMsgQuery', {
                  method: 'POST',
                  headers: {
                    authorization: window.localStorage['feathers-jwt'],
                  },
                  data: {
                    service: 'message',
                    event: 'msg',
                    title: '訪客辨識加時成功',
                    content: `住戶:${
                      carArr[0].householdNumber
                    },訪客辨識加時至:${new Date(
                      carArr[0].faceEndTime
                    ).toLocaleString()}成功`,
                    type: 'success',
                    class: 'visitorAppointmentRegistration',
                    duration: 8000,
                    redirect: '/ezpro/visitor/visitorAppointmentFrontDesk',
                    query: {
                      householdNumbers: {
                        $in: [carArr[0].householdNumber],
                      },
                      firebaseClass: '訪客管理',
                    },
                  },
                })
                  .then((res) => {
                    console.log('==send message Success:', res);
                    // Message.success('已傳送推播給住戶');
                  })
                  .catch((error) => {
                    console.error('==send message fail:', error);
                  });
              }
            });
          } else {
            Message.error('查無此車牌');
            setAddTimeDialog(true);
          }
        }}
        onCancel={() => {
          setCount(0);
          setMinute(0);
          setVisitorId('');
          setAddTimeDialog(false);
        }}
        onClose={() => {
          setCount(0);
          setMinute(0);
          setVisitorId('');
          setAddTimeDialog(false);
        }}
      >
        <h2>新增訪客時效</h2>
        <Form.Item label="請輸入欲加時間">
          <div className={styles.time}>
            <NumberPicker
              min={0}
              value={count}
              onChange={(value) => {
                if (value) {
                  setCount(value);
                } else {
                  setCount(0);
                }
              }}
            />
            <p>小時</p>
            <TimePicker
              placeholder="請選擇時間"
              format="mm"
              value={minute}
              onChange={(value) => {
                if (value) {
                  setMinute(value);
                } else {
                  setMinute(0);
                }
              }}
            />
            <p>分鐘</p>
          </div>
        </Form.Item>
      </Dialog>

      <div className={styles.btnBox}>
        {/* <Button className={styles.addBtn} type="normal" onClick={() => {
          setAddTimeDialog(true)
        }}>車牌加時</Button> */}
        {/* filter搜尋 */}
        <Input
          className={styles.input}
          size="large"
          placeholder="輸入搜尋文字"
          onChange={searchRender}
          aria-label="this is input"
        />
      </div>
      <Card free>
        <Card.Content>
          <Table dataSource={currentPosts} onSort={onTableSort}>
            {/* <Table.Column
              title="流水號"
              width={100}
              lock='left'
              cell={(value, index, record) => {
                return (
                  index
                )
              }} /> */}
            <Table.Column
              title="預約時間"
              dataIndex="reservationTimeStart"
              width={200}
              sortable
              cell={(_value, _index, record) => {
                return (
                  <>
                    {moment(record.reservationTimeStart).format(
                      'YYYY-MM-DD HH:mm:ss'
                    )}
                  </>
                );
              }}
            />
            <Table.Column
              title="來訪時間"
              dataIndex="faceEntryTime"
              width={200}
              cell={(_value, _index, record) => {
                const { faceEntryTime, carEntryTime, admissionTime } = record;
                if (faceEntryTime) {
                  return moment(faceEntryTime).format('YYYY-MM-DD HH:mm:ss');
                } else {
                  const otherEntryTimes = [carEntryTime, admissionTime];
                  const visitorEntryTime = getVisitorEntryTime(otherEntryTimes);
                  return visitorEntryTime;
                }
              }}
            />
            <Table.Column
              title="訪客姓名"
              dataIndex="visitorsName"
              width={130}
            />
            <Table.Column
              title="受訪人戶號"
              dataIndex="householdNumber"
              width={130}
              sortable
            />
            <Table.Column
              title="人數"
              dataIndex="peopleNumber"
              width={130}
              sortable
            />
            <Table.Column
              title="訪客辨識時效"
              width={211}
              cell={(_value, _index, record) => {
                return (
                  <>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {moment(record.faceEndTime).format('YYYY-MM-DD HH:mm:ss')}
                      {record.faceEndTime < new Date().getTime() && '(已過期)'}
                    </div>
                  </>
                );
              }}
            />
            <Table.Column
              title="操作"
              width={131}
              lock="right"
              cell={(_value, _index, record) => {
                // console.log('==op ', value, index, record);
                return (
                  <Box style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      type="secondary"
                      onClick={() => {
                        // alert(record.carNumber)
                        setAddTimeDialog(true);
                        setVisitorId(record._id);
                      }}
                    >
                      訪客加時
                    </Button>
                  </Box>
                );
              }}
            />
          </Table>
          <Pagination
            className={styles.pagination}
            total={visitorAppointmentArr.length}
            pageSize={postsPerPage}
            totalRender={(total) => `Total: ${total}`}
            onChange={(pageNumber) => {
              setCurrentPage(pageNumber);
            }}
          />
        </Card.Content>
      </Card>
    </>
  );
};

export default VisitorAccessStatisticsList;
